/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";
import { TechBox } from "../../AdminList.styled";
import { getDateFormat } from "@utils/datePickerUtils";

const GeneralInfo = (props) => {
  const { t, data, column } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        {column === "id" && <div>{"#" + data.id}</div>}
        {column === "name" && <div>{data.name}</div>}
        {column === "email" && <div>{t(data.email)}</div>}
        {column === "isTech" && (
          <TechBox color={data.isTech ? "#32A728" : "#F08046"}>
            {data.isTech ? t("GENERAL_YES") : t("GENERAL_NO")}
          </TechBox>
        )}
        {column === "lastLogin" && (
          <div>
            {getDateFormat(data.lastLogin, "YYYY-MM-DD HH:mm:ss", "HH:mm")}
          </div>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

GeneralInfo.defaultProps = {
  page: null,
};

export default withTranslation()(GeneralInfo);
